import React from 'react';
import { Route, Switch } from "react-router-dom";
import MakerReportsModule from "./maker-reports-module/maker-reports-module";



const Maker_Reports = () => {
  return (
    <Switch>
      <Route exact path="/security">
        <MakerReportsModule />
      </Route>
    </Switch>
  )
}

export default Maker_Reports;



